import createReducer from 'Rentlio/state/utils/createReducer'

const initialState = {}

const propertyIntegrations = createReducer(initialState)({})

export default propertyIntegrations
